import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import printJS from "print-js"; // Pastikan Anda menginstal printJS

const PrintTicket = ({ initialData, onSuccess, guide }) => {
  const printRef = useRef();

  // Included items (meals)
  const [includedItems, setIncludedItems] = useState([
    { name: "Egg Sandwich", qty: 0 },
    { name: "Vegetarian", qty: 0 },
    { name: "French Fries Only", qty: 0 },
  ]);

  // Form data including note
  const [formData, setFormData] = useState({
    activities: includedItems,
    guest_pax: 0,
    note: "",
  });

  // Update guest_pax dynamically
  useEffect(() => {
    const totalQty = includedItems.reduce((sum, item) => sum + item.qty, 0);
    setFormData((prev) => ({
      ...prev,
      guest_pax: totalQty,
      activities: includedItems,
    }));
  }, [includedItems]);

  // Handle quantity change
  const handleQtyChange = (index, newQty) => {
    const updatedItems = includedItems.map((item, i) =>
      i === index ? { ...item, qty: newQty } : item
    );
    setIncludedItems(updatedItems);
  };

  const handlePrint = () => {
    Swal.fire({
      title: "Confirm Print",
      text: "Are you sure you want to print this ticket 3 times?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Print!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const printContent = printRef.current;
        if (!printContent) {
          console.error("Print reference not found");
          return;
        }

        const labels = ["GUIDE", "RESTO", "CUSTOMER"]; // Cetak 3 kali dengan label berbeda

        labels.forEach((label, index) => {
          setTimeout(() => {
            const invoiceContent = `
            <html>
              <head>
                <title>Print Ticket & Meal</title>
                <style>
                  @page { 
                    size: 58mm auto; /* Ukuran kertas thermal printer */
                    margin: 0;
                  }
                  body {
                    font-family: Arial, sans-serif; 
                    text-align: center;
                    width: 58mm; /* Pastikan sesuai ukuran printer */
                    margin: 0;
                    padding: 5px;
                  }
                  .printable { 
                    display: block !important; 
                    padding: 10px; 
                    border: 1px solid #000; 
                  }
                  .border-dashed { 
                    border-top: 1px dashed #000; 
                    margin: 8px 0; 
                  }
                  .title {
                    font-family: "Georgia", "Times New Roman", serif; 
                    font-size: 16px; 
                    font-weight: bold;
                  }
                  .label {
                    font-family: "Arial Black", "Impact", sans-serif; 
                    font-size: 14px; 
                    font-weight: bold;
                    text-transform: uppercase;
                  }
                  .track {
                    font-family: "Courier New", monospace; 
                    font-size: 40px; 
                    font-weight: bold; 
                    margin: 5px 0;
                  }
                  ul {
                    padding-left: 0; 
                    list-style-type: none; 
                    text-align: left; 
                    font-size: 12px; 
                  }
                </style>
              </head>
              <body>
                <div class="text-center">
                  <h2 class="label">${label}</h2> <!-- GUIDE, RESTO, CUSTOMER -->
                </div>
                ${printContent.innerHTML}
              </body>
            </html>
          `;

            // **Gunakan printJS**
            try {
              printJS({
                printable: invoiceContent,
                type: "raw-html",
                targetStyles: ["*"],
              });
            } catch (error) {
              console.error("Error with printJS, trying fallback:", error);

              // **Fallback ke iframe jika printJS gagal**
              const printFrame = document.createElement("iframe");
              printFrame.style.position = "absolute";
              printFrame.style.width = "0px";
              printFrame.style.height = "0px";
              printFrame.style.border = "none";
              document.body.appendChild(printFrame);

              const printDoc = printFrame.contentWindow.document;
              printDoc.open();
              printDoc.write(invoiceContent);
              printDoc.close();

              setTimeout(() => {
                printFrame.contentWindow.print();
                document.body.removeChild(printFrame);
              }, 500);
            }

            if (index === labels.length - 1) {
              Swal.fire("Success", "The tickets have been printed!", "success");
            }
          }, index * 1000); // Delay setiap cetakan
        });
      } else {
        Swal.fire("Cancelled", "Print operation cancelled.", "info");
      }
    });
  };

  // const handlePrintv3 = () => {
  //   Swal.fire({
  //     title: "Confirm Print",
  //     text: "Are you sure you want to print this ticket 3 times?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes, Print!",
  //     cancelButtonText: "Cancel",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       const printContent = printRef.current;
  //       if (!printContent) {
  //         console.error("Print reference not found");
  //         return;
  //       }

  //       const labels = ["GUIDE", "RESTO", "CUSTOMER"]; // Labels for each print

  //       labels.forEach((label, index) => {
  //         setTimeout(() => {
  //           const printWindow = window.open("", "_blank");
  //           if (!printWindow) {
  //             console.error("Failed to open print window");
  //             return;
  //           }

  //           // Inject font styles & print content
  //           printWindow.document.write(`
  //             <html>
  //               <head>
  //                 <title>Print Ticket & Meal</title>
  //                 <style>
  //                   @media print {
  //                     body {
  //                       font-family: Arial, sans-serif; 
  //                       width: 58mm; 
  //                       text-align: center;
  //                     }
  //                     .printable { 
  //                       display: block !important; 
  //                       padding: 10px; 
  //                       border: 1px solid #000; 
  //                     }
  //                     .border-dashed { 
  //                       border-top: 1px dashed #000; 
  //                       margin: 8px 0; 
  //                     }
  //                     ul { 
  //                       padding-left: 0; 
  //                       list-style-type: none; 
  //                       text-align: left; 
  //                       font-size: 12px; 
  //                     }
  //                     .title {
  //                       font-family: "Georgia", "Times New Roman", serif; 
  //                       font-size: 16px; 
  //                       font-weight: bold;
  //                     }
  //                     .label {
  //                       font-family: "Arial Black", "Impact", sans-serif; 
  //                       font-weight: bold;
  //                       text-transform: uppercase;
  //                     }
  //                     .track {
  //                       font-family: "Courier New", monospace; 
  //                       font-size: 50px; 
  //                       font-weight: bold; 
  //                       margin: 5px 0;
  //                     }
  //                   }
  //                 </style>
  //               </head>
  //               <body>
  //                 <div class="text-center">
  //                   <h2 class="label">${label}</h2> <!-- GUIDE, RESTO, CUSTOMER -->
  //                 </div>
  //                 ${printContent.innerHTML}
  //               </body>
  //             </html>
  //           `);
  //           printWindow.document.close();
  //           printWindow.focus();

  //           setTimeout(() => {
  //             printWindow.print();
  //             printWindow.close();

  //             if (index === labels.length - 1) {
  //               Swal.fire(
  //                 "Success",
  //                 "The tickets have been printed!",
  //                 "success"
  //               );
  //               onSuccess();
  //             }
  //           }, 500);
  //         }, index * 1000); // Delay each print slightly
  //       });
  //     } else {
  //       Swal.fire("Cancelled", "Print operation cancelled.", "info");
  //     }
  //   });
  // };

  // const handlePrintv2 = () => {
  //   Swal.fire({
  //     title: "Confirm Print",
  //     text: "Are you sure you want to print this ticket 3 times?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes, Print!",
  //     cancelButtonText: "Cancel",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       const printContent = printRef.current;
  //       if (!printContent) {
  //         console.error("Print reference not found");
  //         return;
  //       }

  //       const labels = ["GUIDE", "RESTO", "CUSTOMER"]; // Labels for each print

  //       labels.forEach((label, index) => {
  //         setTimeout(() => {
  //           const printWindow = window.open("", "_blank");
  //           if (!printWindow) {
  //             console.error("Failed to open print window");
  //             return;
  //           }

  //           // Inject label into the print content
  //           printWindow.document.write(`
  //             <html>
  //               <head>
  //                 <title>Print Ticket & Meal</title>
  //                 <style>
  //                   @media print {
  //                     body { font-family: Arial, sans-serif; width: 58mm; text-align: center; }
  //                     .printable { display: block !important; padding: 10px; border: 1px solid #000; }
  //                     .border-dashed { border-top: 1px dashed #000; margin: 8px 0; }
  //                     ul { padding-left: 0; list-style-type: none; text-align: left; font-size: 12px; }
  //                   }
  //                 </style>
  //               </head>
  //               <body>
  //                 <div class="text-center">
  //                   <h2>${label}</h2> <!-- Print label -->
  //                 </div>
  //                 ${printContent.innerHTML}
  //               </body>
  //             </html>
  //           `);
  //           printWindow.document.close();
  //           printWindow.focus();

  //           setTimeout(() => {
  //             printWindow.print();
  //             printWindow.close();

  //             if (index === labels.length - 1) {
  //               Swal.fire(
  //                 "Success",
  //                 "The tickets have been printed!",
  //                 "success"
  //               );
  //               onSuccess();
  //             }
  //           }, 500);
  //         }, index * 1000); // Delay each print slightly
  //       });
  //     } else {
  //       Swal.fire("Cancelled", "Print operation cancelled.", "info");
  //     }
  //   });
  // };

  // Handle print function
  const handlePrintVold = () => {
    Swal.fire({
      title: "Confirm Print",
      text: "Are you sure you want to print this ticket?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Print!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const printContent = printRef.current;
        if (!printContent) {
          console.error("Print reference not found");
          return;
        }

        const printWindow = window.open("", "_blank");
        if (!printWindow) {
          console.error("Failed to open print window");
          return;
        }

        printWindow.document.write(`
          <html>
            <head>
              <title>Print Ticket & Meal</title>
              <style>
                @media print {
                  body { font-family: Arial, sans-serif; width: 58mm; text-align: center; }
                  .printable { display: block !important; padding: 10px; border: 1px solid #000; }
                  .border-dashed { border-top: 1px dashed #000; margin: 8px 0; }
                  ul { padding-left: 0; list-style-type: none; text-align: left; font-size: 12px; }
                }
              </style>
            </head>
            <body>${printContent.innerHTML}</body>
          </html>
        `);
        printWindow.document.close();
        printWindow.focus();

        setTimeout(() => {
          printWindow.print();
          printWindow.close();
          Swal.fire("Success", "The ticket has been printed!", "success");
          onSuccess();
        }, 500);
      } else {
        Swal.fire("Cancelled", "Print operation cancelled.", "info");
      }
    });
  };

  const today = new Date();
  const date = today.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  const time = today.toLocaleTimeString("id-ID", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  return (
    <form className="d-flex flex-column" style={{ height: "100%" }}>
      <div className="action-sheet-content flex-grow-1">
        {/* Activity & Meal Detail */}
        <div className="card mb-3">
          <div className="card-header">
            <h5 className="card-title">Activity & Meal Detail</h5>
          </div>
          <div className="card-body">
            <div className="col-12 rounded p-3 mb-2 bg-light">
              {includedItems.map((item, index) => (
                <div className="row mt-2" key={index}>
                  <div className="col-md-4">
                    <label className="form-label">Item</label>
                    <input
                      type="text"
                      value={item.name}
                      className="form-control"
                      readOnly
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label">QTY</label>
                    <input
                      type="number"
                      value={item.qty}
                      className="form-control"
                      min="0"
                      onChange={(e) =>
                        handleQtyChange(index, Number(e.target.value))
                      }
                    />
                  </div>
                </div>
              ))}

              {/* Note Section */}
              <div className="row mt-2">
                <div className="col-md-6">
                  <label className="form-label">Note</label>
                  <textarea
                    className="form-control"
                    value={formData.note}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, note: e.target.value }))
                    }
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Print Button */}
      <div className="form-group mt-auto d-grid">
        <button
          type="button"
          className="btn btn-primary btn-block"
          onClick={handlePrint}
        >
          Print Ticket & Meal Voucher
        </button>
      </div>

      {/* Printable Content */}
      <div
        ref={printRef}
        className="printable card border rounded shadow-sm"
        style={{ display: "none" }}
      >
        <div className="text-center">
          <img
            src="/Kuber.jpeg"
            alt="Company Logo"
            style={{ width: "80px", height: "auto" }}
          />
        </div>

        <div className="card-body text-center">
          <p className="title">
            <strong>TICKET & MEAL VOUCHER</strong>
          </p>
        </div>
        <div className="border-dashed"></div>

        {/* Booking Details */}
        <div className="card-body text-start">
          <small>
            <strong>Time : </strong>
            {time}{" "}
          </small>
          <small>
            <strong>Date : </strong>
            {date}{" "}
          </small>
          <small>
            <strong>Code : </strong>
            {initialData.code}
          </small>

          <p>
            <strong>Activity:</strong>
          </p>
          <ul>
            <li>
              <strong>Total Pax:</strong> {initialData.guest_pax}
            </li>
            {initialData.activities.map((activity, index) => (
              <li key={index}>
                <strong>{activity.activity}</strong>: {activity.qty} pax
              </li>
            ))}
          </ul>

          <div className="alert alert-info text-center">
            <h4 className="alert-heading">Trip Option</h4>
            {/* <p style={{ fontSize: "100px", fontWeight: "bold" }}>
              {initialData.track}
            </p> */}
            {/* <p style="font-size: 40px; font-weight: bold; margin: 5px 0;"> */}
            <p
              style={{ fontSize: "90px", fontWeight: "bold", margin: "5px 0" }}
            >
              {initialData.track}
            </p>
          </div>

          {/* Operator Input */}
          <div className="form-group">
            <label>
              <strong>Operator By:</strong>
            </label>
            <p>{guide?.name || "No guide assigned"}</p>
            <p>______________________</p>
          </div>
        </div>

        <div className="border-dashed"></div>

        {/* Meals Section */}
        <div className="card-body">
          <p>
            <strong>Included Meals:</strong>
          </p>
          <ul>
            {includedItems.map((item, index) => (
              <li key={index}>
                <strong>{item.name}</strong>: {item.qty}
              </li>
            ))}
          </ul>

          {/* Note Display */}
          <div className="form-group">
            <label>
              <strong>Note:</strong>
            </label>
            <p>{formData.note || "No additional notes"}</p>
            <p>______________________</p>
          </div>
        </div>
        <div className="border-dashed"></div>

        {/* Footer */}
        <div className="card-body text-center">
          <small>Thank you for using our service!</small> <br />
          <small>Have a great day!</small>
          {/* GUIDE, RESTO, CUSTOMER */}
        </div>
        <div className="border-dashed"></div>
      </div>
    </form>
  );
};

export default PrintTicket;
